import styled, { css } from 'styled-components';
import { black, maroon, primary, mediumGrey } from 'constants/color';

export const StyledCaption = styled.h1`
  margin: 5px 0;
  color: ${black};
`;

export const StyledSubHeading = styled.h6`
  font-size: 12px;
  color: ${primary};
  margin: 1px 0 5px 0;
`;

export const StyledTableRow = styled.tr`
  ${function ({ $sub }) {
    return (
      !$sub &&
      css`
        &:not(:first-child) {
          & td {
            border-top: 1px solid ${primary};
          }
        }
      `
    );
  }}
  &:last-child {
    & td {
      border-bottom: 1px solid ${primary};
    }
  }
`;

export const StyledErrorMessage = styled.p`
  color: ${maroon};
  font-size: 12px;
  font-weight: 400;
  margin: 2px 0 0 0;

  ${function ({ $main }) {
    return (
      $main &&
      css`
        font-size: 14px;
        padding: 5px 10px;
        margin: 5px 0 10px 5px;
        background-color: #f8d7da;
      `
    );
  }}
`;

export const StyledButtonWrapper = styled.div`
  width: 20%;
  min-height: 1px;
  position: relative;
  padding-left: 15px;
  padding-right: 15px;
  /* Mobile Devices */
  @media (max-width: 480px) {
    width: 100%;
    padding-left: 0;
    margin-top: 10px;
  }
  /* Portrait Tablets and Ipads */
  @media (min-width: 768px) and (max-width: 1024px) {
    width: 100%;
  }
`;

export const StyledTableWrapper = styled.div`
  /* Mobile Devices */
  @media (max-width: 480px) {
    overflow-x: auto;
  }
`;

export const StyledWrapper = styled.div`
  /* Mobile Devices */
  @media (max-width: 480px) {
    overflow: hidden;
  }
`;

export const StyledLabel = styled.label`
  margin: 5px 0;
  font-size: 12px;
  color: ${black};
`;

export const StyledQuantityWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledRoundButton = styled.button`
  width: 20px;
  height: 20px;
  border: none;
  color: white;
  display: flex;
  cursor: pointer;
  font-size: 20px;
  border-radius: 50%;
  text-align: center;
  align-items: center;
  justify-content: center;
  background-color: ${function ({ $minus }) {
    return $minus ? mediumGrey : primary;
  }};
`;

export const StyledInput = styled.input`
  color: #000;
  border: none;
  cursor: text;
  outline: none;
  font-size: 12px;
  font-weight: normal;
  box-sizing: border-box;
  border-bottom: 1px solid ${mediumGrey};
  &:read-only {
    border: none;
  }
  &[type='number'] {
    width: 40px;
    text-align: center;
  }
  &:focus {
    ${function ({ $unsaved }) {
      return (
        $unsaved &&
        css`
          border-bottom: 1px solid ${primary};
        `
      );
    }}
    &[name]:not([name='sku']) {
      border-bottom: 1px solid ${primary};
    }
  }
  &[type='number']::-webkit-inner-spin-button,
  &[type='number']::-webkit-outer-spin-button {
    margin: 0;
    -webkit-appearance: none;
  }
`;
